export const homeRoute = '/'

// general pages
export const pageRoute = (slug = '') => `/${slug}`

// hire it
export const hireCategoriesRoute = '/hire-it/hire-categories'

// products
export const productsRoot = '/products'
export const productsRoute = '/hire-it/hire-categories'
export const hireFromUsRoute = 'hire-it/why-hire-from-us'
export const quoteFormRoute = '/request-a-quote'
export const productRoute = (slug = '') => `${productsRoute}/${slug}`

// branches
export const branchesRoute = '/branches'
export const branchRoute = (slug = '') => `${branchesRoute}/${slug}`

// basket
export const basketRoute = '/basket'

// billing details
export const billingDetailsRoute = '/billing-details'

// thank you
export const thankYouRoute = '/thank-you'

// news
export const newsRoute = '/news'
export const newsArticleRoute = (slug = '') => `${newsRoute}/${slug}`

// case studies
export const caseStudiesRoute = '/case-studies'
export const caseStudyRoute = (slug = '') => `${caseStudiesRoute}/${slug}`

// Open credit account
export const openCreditAccount = '/open-a-credit-account'
// Export World Wide
export const exportWorldWide = '/export'

export const sustainabilitiesRoute = '/sustainability-at-bss'
export const sustainabilityRoute = (slug = '') => `${sustainabilitiesRoute}/${slug}`



// WEBPACK FOOTER //
// ./src/constants/routes.js